/**
 * @generated SignedSource<<c387cf929f78446838745aa7997fc636>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AgentPricingAssignmentsProductsQuery$variables = Record<PropertyKey, never>;
export type AgentPricingAssignmentsProductsQuery$data = {
  readonly modelsHierarchy: ReadonlyArray<{
    readonly code: string;
    readonly name: string;
    readonly productID: string;
  }>;
};
export type AgentPricingAssignmentsProductsQuery = {
  response: AgentPricingAssignmentsProductsQuery$data;
  variables: AgentPricingAssignmentsProductsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ProductHierarchy",
    "kind": "LinkedField",
    "name": "modelsHierarchy",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "productID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AgentPricingAssignmentsProductsQuery",
    "selections": (v0/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AgentPricingAssignmentsProductsQuery",
    "selections": (v0/*:: as any*/)
  },
  "params": {
    "cacheID": "563f00ae9d303fee10c1e78b17d0a8b9",
    "id": null,
    "metadata": {},
    "name": "AgentPricingAssignmentsProductsQuery",
    "operationKind": "query",
    "text": "query AgentPricingAssignmentsProductsQuery {\n  modelsHierarchy {\n    productID\n    name\n    code\n  }\n}\n"
  }
};
})();

(node as any).hash = "f5ce0b7626cbb2c9cbc3245340d63191";

export default node;
